import {addToCart} from './add-to-cart';
const addToCartTable = () => {

    let btnsToCart = document.querySelectorAll('[data-js-event=addToCartTable]');
    if (btnsToCart) {
        btnsToCart.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                let id = btn.dataset.id;
                if (id && parseInt(id) > 0) {
                    let qty = 1;
                    let inputQuantity = btn.closest('tr').querySelector('.item-counter input');
                    if (inputQuantity) {
                        qty = parseInt(inputQuantity.value);
                        if (isNaN(qty)) {
                            qty = 1;
                        }
                    }
                    addToCart(id, qty);
                }
            });
        })
    }

}

export {addToCartTable}
